/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_Mk_77_107(e) {
  let t = (0, ReactCompiler.c)(10),
    { etiqueta: n, valor: r, sub: i } = e,
    a;
  t[0] === n
    ? (a = t[1])
    : ((a = (
        <p className={`text-xs leading-tight text-(--text)`} children={n} />
      )),
      (t[0] = n),
      (t[1] = a));
  let o;
  t[2] === r
    ? (o = t[3])
    : ((o = (
        <p
          className={`mt-1 text-xl font-medium text-(--text-h) sm:text-2xl`}
          children={r}
        />
      )),
      (t[2] = r),
      (t[3] = o));
  let s;
  t[4] === i
    ? (s = t[5])
    : ((s = i && <p className={`text-xs text-(--text)`} children={i} />),
      (t[4] = i),
      (t[5] = s));
  let c;
  return (
    t[6] !== a || t[7] !== o || t[8] !== s
      ? ((c = (
          <div
            className={`rounded-2xl border border-(--border) bg-(--bg) p-3 sm:p-4`}
            children={[a, o, s]}
          />
        )),
        (t[6] = a),
        (t[7] = o),
        (t[8] = s),
        (t[9] = c))
      : (c = t[9]),
    c
  );
}
